import { render, staticRenderFns } from "./WordCloudContent.vue?vue&type=template&id=f4dead24&scoped=true&"
import script from "./WordCloudContent.vue?vue&type=script&lang=js&"
export * from "./WordCloudContent.vue?vue&type=script&lang=js&"
import style0 from "./WordCloudContent.vue?vue&type=style&index=0&id=f4dead24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4dead24",
  null
  
)

export default component.exports